import { LogoMark, LogoWordmark } from "./Logo";
import { STOREFRONT_URL } from "../data/products";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#0B0C0E]">
    <div className="mx-auto max-w-7xl px-5 py-14 md:px-8">
      <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
        <div className="max-w-sm">
          <div className="flex items-center gap-3">
            <LogoMark size={34} />
            <LogoWordmark />
          </div>
          <p className="mt-4 text-sm leading-relaxed text-slate-400">
            Hand-picked Amazon finds across electronics, home &amp; kitchen,
            fashion, toys, and beauty — researched weekly by{" "}
            <span className="font-mono text-[#FFB800]">rakeshsharma</span>.
          </p>
        </div>
        <div className="flex flex-col gap-3 text-sm">
          <a href="#products" className="text-slate-300 transition-colors hover:text-[#FF9900]">Curated Finds</a>
          <a href="#why" className="text-slate-300 transition-colors hover:text-[#FF9900]">Why Trust Us</a>
          <a
            href={STOREFRONT_URL}
            target="_blank"
            rel="noopener noreferrer sponsored"
            className="text-slate-300 transition-colors hover:text-[#FF9900]"
          >
            Shop on Amazon
          </a>
        </div>
      </div>
      <div
        data-testid="affiliate-disclosure-footer"
        className="mt-12 rounded-xl border border-white/10 bg-[#121418] p-5 text-xs leading-relaxed text-slate-500"
      >
        <span className="font-semibold text-slate-400">Affiliate Disclosure:</span>{" "}
        rakeshsharma is a participant in the Amazon Services LLC Associates
        Program. As an Amazon Associate, we earn from qualifying purchases made
        through links on this site — at no extra cost to you. Product prices and
        availability are accurate as of the date/time indicated and are subject to
        change on Amazon.
      </div>
      <p className="mt-8 text-xs text-slate-600">
        © {new Date().getFullYear()} rakeshsharma — All rights reserved.
      </p>
    </div>
  </footer>
);
